export const INITIAL_DRAWER_WIDTH = 500;

export const INLINE_WORKSPACE_DRAWER_DURATION = 500; // in ms
